import React from 'react';
import { OptimizelyArticlePage, OptimizelyEmployeeTeaserListBlock } from '../../types/optimizely/blocks';
import { EmployeeStoryCard, EmployeesBlock } from '../EmployeesBlock/EmployeesBlock';
import { getDepartment } from '../../utils/getDepartment';
import { getButtonVariant } from '../../utils/getButtonVariant';

export interface EmployeesBlockWrapperProps {
  module: OptimizelyEmployeeTeaserListBlock;
  isFrontPage?: boolean;
}

const mapArticlePagesToEmployeeStories= (articles: OptimizelyArticlePage[]): EmployeeStoryCard[]  => {
  if (!articles || articles.length == 0) {
    const result: EmployeeStoryCard[] = [];
    return result;
  }

  return articles.map(article => {
    return {
      title: article.mainIntro?.value,
      link: article.contentLink?.url,
      image: article.listImage?.expandedValue?.url,
      department: getDepartment(article.organization?.value?.[0]),
    }
  })
};

const EmployeesBlockWrapper: React.FC<EmployeesBlockWrapperProps> = ({ module, isFrontPage }) => {
  return (
    <EmployeesBlock
      isFrontPage={isFrontPage}
      sectionName={module.title?.value}
      sectionSubName={module.secondaryTitle?.value}
      employeeStories={mapArticlePagesToEmployeeStories(module.content?.expandedValue)}
      buttonLink={module.callToActionButton?.buttonLink?.value}
      buttonText={module.callToActionButton?.linkText?.value}
      buttonVariant={getButtonVariant(module.callToActionButton?.buttonType?.value)}
    />
  )
}

export default EmployeesBlockWrapper;
